import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import intlTelInput from 'intl-tel-input';

@Directive({
  selector: '[appIntlTelInput]'
})
export class IntlTelInputDirective implements OnInit {
    @Output() countrychange: EventEmitter<string> = new EventEmitter();
    @Input()  initialCountry: ElementRef;

    private telInput: any
  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.telInput = intlTelInput(this.initialCountry, {
        preferredCountries: ['mx'],
        separateDialCode: true,
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js'
      });



    //   this.telInput.node.addEventListener('countrychange', () => {
       
    // });
  }

  @HostListener('change', ['$event'])
  onChange(event: Event): void {
     // Obtener el código de país seleccionado
     const countryCode = this.telInput.getSelectedCountryData().dialCode;
     console.log(countryCode);
     // Emitir el evento con el código del país seleccionado
     this.countrychange.emit(countryCode);
  }
}